import React from "react";
import { Stack, Typography } from "@mui/material";

import {
  HubButton,
  HubHookFormDatePicker,
  HubHookFormInput,
  HubHookFormRoleSelect,
  HubHookFormSelect,
  HubHookFormTagInput,
  HubHookFormWrapper,
  UserDetailIcon,
} from "../../../components";
import { DEPARTMENTS, FOUNDRIES } from "../../../constants";
import { EMPLOYEE_TYPES } from "../../../constants/employees";

import { FormRow, SectionLabel } from "../components";
import { StyledFooter, StyledFormCard, StyledHero } from "../styles";
import { useUserProfile } from "../context";

const ProfileTab = () => {
  const { data, canEdit, showAdminSection, isSaving, defaults, onSubmit } =
    useUserProfile();

  const email = `${data?.employeeId ? `Employee ${data.employeeId}` : ""}${data?.email ? ` · ${data.email}` : ""}`;

  return (
    <HubHookFormWrapper defaultValues={defaults} onSubmit={onSubmit}>
      <StyledFormCard>
      <StyledHero>
        <UserDetailIcon
          size={64}
          variant="rounded"
          user={{ hueShift: data?.id, name: data?.name, email }}
          sx={{
            cursor: "default",
            ".HubUser-name": { fontSize: "16px" },
            ".HubUser-email": { fontSize: "12px" },
          }}
        />
        <div />
      </StyledHero>

      <SectionLabel>Basic Profile</SectionLabel>
      <FormRow label="Full name" helper="Your display name.">
        <HubHookFormInput
          name="name"
          placeholder="Full name"
          disabled={!canEdit}
          shouldUnregister={false}
          label=""
          required
        />
      </FormRow>
      <FormRow
        label="Employee ID"
        helper="Generated when the account was created."
      >
        <HubHookFormInput
          name="employeeId"
          shouldUnregister={false}
          disabled
          label=""
        />
      </FormRow>
      <FormRow label="Email" helper="Sign-in address and notifications.">
        <HubHookFormInput
          name="email"
          placeholder="you@ipcfoundry.com"
          disabled={!canEdit}
          shouldUnregister={false}
          label=""
        />
      </FormRow>
      <FormRow label="Phone" helper="Optional contact number.">
        <HubHookFormInput
          name="phone"
          placeholder="(800) 000-0000"
          shouldUnregister={false}
          disabled={!canEdit}
          label=""
        />
      </FormRow>

      {showAdminSection && (
        <>
          <SectionLabel>Employment</SectionLabel>
          <FormRow
            label="Primary location"
            helper="Default foundry this user reports to."
          >
            <HubHookFormSelect
              name="locationId"
              options={FOUNDRIES}
              shouldUnregister={false}
              label=""
              required
            />
          </FormRow>
          <FormRow
            label="Additional locations"
            helper="Other foundries this user can be scheduled at."
          >
            <HubHookFormTagInput
              name="locationIds"
              options={FOUNDRIES}
              shouldUnregister={false}
              label=""
              placeholder="Add a location…"
            />
          </FormRow>
          <FormRow label="Role" helper="Drives permissions across the app.">
            <HubHookFormRoleSelect
              name="roleId"
              locationId={Number(defaults?.locationId) || 1}
              shouldUnregister={false}
              label=""
              required
            />
          </FormRow>
          <FormRow
            label="Departments"
            helper="Stations this user can clock into."
          >
            <HubHookFormTagInput
              name="departmentIds"
              options={DEPARTMENTS}
              shouldUnregister={false}
              label=""
              placeholder="Add a department…"
            />
          </FormRow>
          <FormRow
            label="Worker type"
            helper="Full-time vs part-time classification."
          >
            <HubHookFormSelect
              name="type"
              options={EMPLOYEE_TYPES}
              label=""
              shouldUnregister={false}
            />
          </FormRow>
          <FormRow label="Date of birth">
            <HubHookFormDatePicker
              name="dob"
              label=""
              shouldUnregister={false}
            />
          </FormRow>
          <FormRow label="Date of hire">
            <HubHookFormDatePicker
              name="doh"
              label=""
              shouldUnregister={false}
            />
          </FormRow>
        </>
      )}

      <StyledFooter>
        <HubButton
          variant="contained"
          size="xsmall"
          type="submit"
          label="Save Changes"
          disabled={!canEdit || isSaving}
        />
      </StyledFooter>
    </StyledFormCard>
    </HubHookFormWrapper>
  );
};

export default ProfileTab;
